import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal,Spin } from "antd";

import Modal from "react-modal";

const LotCreationListview = (props) => {
  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const { addForm, update, sId } = props;
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [data, setData] = useState([]);
  const [lotData, setLotData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const loturl = `/api/lotCreation/?orgId=${localStorage.getItem("orgId")}`;

  const { sendRequest: getlotCreation } = useHttp();

  const getData = () => {
    getlotCreation(
      {
        url: loturl,
      },
      (res) => {
        if (res) {
          //console.log(res);
          const sortedData = res.output.sort((a, b) => b.lotId - a.lotId);
          setData(sortedData);
          setLotData(res.output[0]);
          setAllData(res.output);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.lotNo.includes(filetrtext) ||
        item.employeeName.includes(filetrtext) ||
        item.lotQuantity.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: lotDelete } = useHttp();

  const handleDelete = (e, lotId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this Arrival Quality Check detail?",
      onOk() {
        setDeleteLoading(lotId);
        const data = {
          lotId: lotId,
          serviceId: sId,
        };
        //console.log(data);

        lotDelete(
          {
            url: "/api/lotCreation/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            getData();
            setDeleteLoading(false);
          },
          () => {
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    setSelectedData(data);
    const id = (data && data.lotId) || "";
    //console.log(id);

    getlotCreation(
      {
        url: `/api/lotCreation/?lotId=${id}`,
      },
      (res) => {
        //console.log(res);
        setProductDetails(res.productDetail);
      }
    );
    ////console.log(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selectedApprovalData && selectedApprovalData.lotId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    updateApprovalStatus(
      {
        url: "/api/ApproveLots/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        getData();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Lot Creation</label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Lot
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Lot Created date</th>
                          <th>Assigned Supervisor</th>

                          <th>Doc No</th>

                          <th>Lot Quantity</th>
                          <th>Unit</th>
                          <th>Lot Amount</th>
                          <th>Approval</th>

                          {canDelete === "block" && <th>Delete</th>}
                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.lotDate}</td>
                                <td>{itm.employeeName}</td>

                                <td>{itm.lotNo}</td>
                                <td>{itm.lotQuantity}</td>
                                <td>{itm.unitAbbreviation}</td>
                                <td>{itm.lotAmount}</td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    disabled={
                                      itm.nextlevel == 1
                                        ? itm.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : itm.approved == 0 &&
                                          itm.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>

                                {canDelete === "block" && (
                                  <td>
                                    {deleteLoading === itm.lotId ? (
                                      <Spin />
                                    ) : (
                                      <button
                                        onClick={(e) =>
                                          handleDelete(e, itm.lotId)
                                        }
                                        className="btn"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    )}
                                  </td>
                                )}
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="">
            <div className="">
              <h3 className="card-title">Lot Creation Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsModalOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Date: {selectedData.lotDate}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Doc No: {selectedData.lotNo}
              </p>
              <p className="col-md-6">
                Assigned Supervisor: {selectedData.employeeName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Lot Quantity: {selectedData.lotQuantity}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Unit: {selectedData.unitAbbreviation}
              </p>
              <p className="col-md-6">Lot Amount: {selectedData.lotAmount}</p>
            </div>

            <div className="row">
              {" "}
              <h5 className="card-title">Product Details</h5>
            </div>

            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Procurement No</th>
                  <th>Farmer Name</th>
                  <th>Item Type</th>
                  <th>Item Category/Variety</th>
                  <th>Item Description</th>
                  <th>Item Quantity</th>
                  <th>Rate</th>
                  <th>amount</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.procurementNo}</td>
                        <td>{itm.farmerName}</td>
                        <td>{itm.cropName}</td>
                        <td>{itm.varietyName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemQuantity}</td>
                        <td>{itm.rate}</td>

                        <td>{itm.amount}</td>
                        <td>{itm.unitAbbreviation}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>

      <AntModal
        title="Lot Creation Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default LotCreationListview;
